import { registerQuery, registerSubscription } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { map } from 'rxjs';
import { SGCONFIG_ID, SGConfig } from '../db/sg-config.js';

const getGlobalConfig = registerQuery({
  type: () => SGConfig,
  operationName: 'getGlobalConfig',
  resolve: () => async (gqlFields: BaseQLSelectionSet<SGConfig>) => {
    const configCol = await getCollection(SGConfig);
    const config = await configCol.findOne({ _id: SGCONFIG_ID }, { projection: gqlFields });
    if (!config) throw new Error('Global Config not found');
    return config as SGConfig;
  },
});

const subcribeGlobalConfig = registerSubscription({
  type: () => SGConfig,
  operationName: 'subscribeGlobalConfig',
  resolve: () => (gqlFields: BaseQLSelectionSet<SGConfig>) =>
    watchQuery<SGConfig>(SGConfig._collectionName, { _id: SGCONFIG_ID }, { projection: gqlFields }).pipe(
      map(configs => configs?.[0]),
    ),
});

export const GlobalConfigAPI = {
  get: getGlobalConfig,
  subscribe: subcribeGlobalConfig,
};
